(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSBajaDetailController', SSBajaDetailController);

    SSBajaDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'SSBaja', 'SSAsignacion'];

    function SSBajaDetailController($scope, $rootScope, $stateParams, previousState, entity, SSBaja, SSAsignacion) {
        var vm = this;

        vm.sSBaja = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('serviciosocialApp:sSBajaUpdate', function(event, result) {
            vm.sSBaja = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
